var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1045.99,
    height: 600,
    viewBox: "0 0 1045.99 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 8024.52,
    y1: 518.78,
    x2: 7908.94,
    y2: 518.78,
    gradientTransform: "matrix(-1, 0, 0, 1, 8612.65, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#eef7ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -62.05,
    y1: 397.35,
    x2: 118.04,
    y2: 397.35,
    gradientTransform: "matrix(-1, 0, 0, 1, 295.36, 0)",
    xlinkHref: "#a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 292.43,
    y1: 159.41,
    x2: 816.03,
    y2: 159.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 597.85,
    y1: 475.46,
    x2: 683.98,
    y2: 475.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 621.68,
    y1: 448.89,
    x2: 638.29,
    y2: 448.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 621.68,
    y1: 452.39,
    x2: 638.29,
    y2: 452.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.75,466s-18.61-31.09-19.89-46.88-10.76-34.59-14.15-35.07.84,15.25.84,15.25-6.54-4.08-9.44-3-13.5,9.27-13.5,9.27,2.42,2.7,3.63,2.45-7,2.17-3.63,4,8.72.8,8.72.8S723.84,423.28,726,423s5.33-7.3,5.33-7.3-.49,11.22,1.94,11,4.08,62.79,13.52,69.32,50.52-2.28,50.52-2.28l-18.44-27.36Z",
    style: {
      fill: "#ffad94"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "474.77 578.92 453.73 588.43 426.23 519.85 454.42 515.22 474.77 578.92",
    style: {
      fill: "#ffad94"
    }
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 330.67,
    y1: 551.64,
    x2: 380.58,
    y2: 551.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395,488s-29.66,10.51-31,19.4-2,45.18-2,45.18a104.74,104.74,0,0,0,19.58,3.27c9.33.45,17.16-21.58,17.16-21.58L387.7,545.75,362,552.58v35.94l89.65-.62-4.37-55.07L449.7,525l7.55-7.56S445.7,490.52,437,488.29s-21.28-2.66-21.28-2.66",
    style: {
      fill: "#14417d"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.84,460.62s-13-4-11.82-14.89,9-13.84,9-13.84-5.8-5.44,2.24-9.34,18-8.86,27.79-2,24.12,3.79,22.11,13.13-12.06,8.86-12.06,8.86L405.83,463Z",
    style: {
      fill: "#7c2b06"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.86,439.1s3.9,15.37,3.43,24.24-3.08,14.43-9,15.61-5.67.59-5.67.59l.47,10.4,5.79,1.78s-3.31,12.77-14.18,10.76-19.63-8.87-19.63-8.87l4.26-3.78-.59-22.7s-12.54.47-12.42-8,6.62-9.94,10.88-7.22,6.38,7.92,6.38,7.92l3.08-.11.47-9.7s3.43-.84,3.19-3.31-3.54-7.57-3.54-7.57S421.59,431.06,427.86,439.1Z",
    style: {
      fill: "#ffad94"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493,571.31h-2.76a7.9,7.9,0,0,0-3.27,0c-2.55.3-3,1.13-3,1.13l-1.84.31c-1.84.31-6.23,3.17-6.23,3.17l-64.27-10.07-12.91-31.57-30.85,23.32,17,23a19.13,19.13,0,0,0,15.35,7.76l72.66.18v0c1.34,0,6.36.08,10.48,0,4.8-.1,4.08-5,6.84-4.49,2.54.47,0-2.34-.45-2.8.41.42,2.87,2.84,5.76,2.18,3.17-.71-.71-3.47-.71-3.47s7.56,3.06,9.29,2.35-3.55-5.52-3.55-5.52,6.62-.2,7.54-3S493,571.31,493,571.31Z",
    style: {
      fill: "#ffad94"
    }
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 531.33,
    y1: 555.38,
    x2: 583.41,
    y2: 575.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830.83,401.9s-14.93-19.52-6.17-28.28c10.54-10.54,21.08-1,41.13-5.14s34.57,26.49,30.72,33.94,0,18.56-27.9,34.7",
    style: {
      fill: "#7c2b06"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.59,454.5s30.81,12.24,32.4,22.88,1.28,44.88,1.28,44.88-4.64-7.27-15.81-6.74-15.29,1.75-15.29,1.75l1.44,6,24.76,29,.76,48.26-96.23.34-.67-93.05-2.85-9.44-9-9.05s13.83-32.18,24.21-34.84a111.5,111.5,0,0,1,17.2-3.19",
    style: {
      fill: "#882c7b"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830,392.69s-2.87,13.15-1.54,24.86.9,20.82,10.51,22.22c4.11.6,5.32,0,5.32,0l-.54,9.57-7.2,3.2s5.34,15,19.17,12.82,20.48-10.43,20.48-10.43l-6.11-4.26,1.86-25s10.39-3.44,9.86-10.36-7.82-14-14.12-4.74c-4.49,6.58-.23,9.38-5.47,9.74l-.26-4-.06-6s-4.56-6-5.53-7.71c-1.85-3.25,1.35-5.59-10.09-5.85S830,392.69,830,392.69Z",
    style: {
      fill: "#ffad94"
    }
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 775.18,
    y1: 488.64,
    x2: 837.21,
    y2: 488.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.14,520.09s2.13,30.32-3.19,35.11-11.71,7.71-21.55,2.93S841,529.67,841,529.67s-10.1,4.79-18.35,2.39-19.68-12.5-20.21-15.42l-.53-2.93s-.78-2.84.21-3.59a3.85,3.85,0,0,1,1.9-.8s-.6-4.49,1.44-4.74a9.77,9.77,0,0,1,4.39.8s.5-3,3.14-2.64a18.66,18.66,0,0,1,5.54,2.09s9,10.87,13.76,10.08a8.23,8.23,0,0,0,6.29-4.39l-.8-6.49s2.69-.59,5.88,2.5a90.93,90.93,0,0,0,15.83,12.1c5.72,3.19,20.21,7.31,20.21,7.31l-.4-9S897.64,504.67,910.14,520.09Z",
    style: {
      fill: "#ffad94"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.34,330.78s-3.16,2.28-22.67,33.64c-10.36,16.66,7.89,69.07,7.89,69.07l64.6-20.92,16.21-19.7s-17.89-18.38-14-53.21",
    style: {
      fill: "#7c2b06"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.22,398.1l-6.74,15.72L180.32,379.4s-1.87-21.7-6-23.19-6.35,3.92-6.35,3.92S157.13,342.36,154.51,345s4.49,18,4.49,18-3-3-5.07,1.12,0,6,0,6-3.72,0-3.3,2.85a6.72,6.72,0,0,0,1.68,3.93s-3.65,3.51-.7,5.19,9.82,8.13,16.13,9.54,23.11,46.38,47.84,59.48c11.13,5.89,28.34-21.33,28.34-21.33l4.77-30.86Z",
    style: {
      fill: "#ffad94"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.2,319.72s7.17-14.57-16.12-26.49c-16-8.19-41.29,1.88-42,28.36-.25,9.09,7.18,14.5,14.59,21.78,17,16.65,9,15.95,16.85,22.24s-6.33,6-6.33,6l4.13-20.23s30.3-3.84,18.08,1.11C295.69,355.56,314.2,319.72,314.2,319.72Z",
    style: {
      fill: "#7c2b06"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.67,463.66s5.89-18.51,0-24.13-5.33-10.66-4.21-21.6,2-12.62,2-12.62-3.37-4.49-11-4.21a79,79,0,0,1-10.1,0s5.05-23.55,24.69-28.32,29.68-11.82,29.68-11.82,19.42,2.56,28.12,2.84,19.64-2.24,25.25,5.33,1.4,28.62,1.4,28.62l-23.28-1.12,14.87,67.05Z",
    style: {
      fill: "#ffd731"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "327.52 397.73 311.16 463.66 286.09 463.66 304.24 396.61 327.52 397.73",
    style: {
      fill: "#ffad94"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.22,328.2s-8.65-13-14.71-4.61.94,13.92,5.21,14.53,3.3.34,3.3.34l-6.57,26.14-8.78,7a37.56,37.56,0,0,0,24.55,10.87c15.43.73,17.31-13,17.31-13l-7.08-1.87-1.75-12.13s6.92,3,13.74-5,6.76-30.71,6.76-30.71l-3.3-8.14c-2.94,3.69-11.34,7.78-15.62,9.75C291.93,322.88,282.22,328.2,282.22,328.2Z",
    style: {
      fill: "#ffad94"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698.05,554.2H603.21a5.75,5.75,0,0,1-5.69-4.94l-9.39-65.9h99.24a5.65,5.65,0,0,1,5.56,4.66l10.69,59.52A5.66,5.66,0,0,1,698.05,554.2Z",
    style: {
      fill: "url(#a)"
    }
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 669.02,
    y1: 584.7,
    x2: 611.49,
    y2: 584.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 523.76,
    y1: 427.91,
    x2: 574.57,
    y2: 427.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 549.16,
    y1: 419.64,
    x2: 562.48,
    y2: 419.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 421.25,
    y1: 366.96,
    x2: 492.24,
    y2: 366.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 37.37,
    y1: 338.44,
    x2: 108.35,
    y2: 338.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 932.46,
    y1: 107.1,
    x2: 894.92,
    y2: 150.87,
    style: {
      fill: "none",
      stroke: "#2d72b8",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 979.09,
    y1: 95.14,
    x2: 1010.62,
    y2: 184.27,
    style: {
      fill: "none",
      stroke: "#2d72b8",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 943.97,
    y1: 261.77,
    x2: 896.67,
    y2: 200.52,
    style: {
      fill: "none",
      stroke: "#2d72b8",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 983.28,
    y1: 259.35,
    x2: 1003.51,
    y2: 231.37,
    style: {
      fill: "none",
      stroke: "#2d72b8",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890.16,
    cy: 175.76,
    r: 24.89,
    style: {
      fill: "none",
      stroke: "#2d72b8",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1014.76,
    cy: 209.16,
    r: 24.89,
    style: {
      fill: "none",
      stroke: "#2d72b8",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.18,185.59l3.66,4.29.33-.39V162.06l-.33-.42-3.66,4.29v19.66",
    style: {
      fill: "#1a476f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.84,189.88l7,3.49.29-.47V158.51l-.29-.36-7,3.48v28.25",
    style: {
      fill: "#1f5b98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.44,165.93l-3.66-4.29-.41.13.08,27.76.33.35,3.66-4.29V165.93",
    style: {
      fill: "#2d72b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.79,193.37l7-3.49V161.63l-7-3.48-.33.45v34.26l.33.51",
    style: {
      fill: "#5294cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.84,158.15h9.94v35.22h-9.94Z",
    style: {
      fill: "#2d72b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.89,225.18h.39l6.36-3.18.11-.15V196.47l-.11-.15-6.36-3.18h-.39v32",
    style: {
      fill: "#5294cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.62,225.18h-.4l-6.35-3.18-.13-.22-.07-25.18.2-.28,6.35-3.18h.4v32",
    style: {
      fill: "#1f5b98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.23,193.14h9v32h-9Z",
    style: {
      fill: "#2d72b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029,208.44l-.21-.05-3.07-.28,0,0-6.36-.25h-9l-6.36.25v-4.85h0l6.36-1.48h9l6.36,1.48,2.34,1.24v-.8l1-.11-.1-.2-3.13-2.24-.1,0-6.36-2h-9l-6.36,2v-4.87l-3.33,3.9v3.4l0,0,1,.11v.82l-1,.53v3.38h0l1,0v1.42h-1v3.39l1,.53v.82l-.95.11,0,0v3.4l3.33,3.9v-4.87l6.36,2h9l6.38-2,.09,0,3.09-2.21.13-.22-1-.11v-.81l-.13-.05-2.11,1.14-.08.16-6.38,1.47h-9l-6.36-1.47v-4.88l6.36.26h9l6.36-.26.15.07,3-.25.21-.11h-1v-1.42l1,0",
    style: {
      fill: "#1a476f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.64,217.13V222l3.33-3.9v-3.38l-3.31,2.4h0m0-2.06h0l3.31-1.78v-3.4l-3.33.3v4.89m0-11.8h0v4.86l3.33.31V205l-3.31-1.77m0-2.06,3.31,2.39v-3.38l-3.33-3.9v4.87h0",
    style: {
      fill: "#2d72b8"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.81,
    y1: 48.81,
    x2: 125.55,
    y2: 48.28,
    style: {
      fill: "none",
      stroke: "#759c3e",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.77,
    y1: 133.47,
    x2: 94.04,
    y2: 71.9,
    style: {
      fill: "none",
      stroke: "#759c3e",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.95,
    cy: 47.57,
    r: 24.89,
    style: {
      fill: "none",
      stroke: "#759c3e",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,42.3l-1.54.5L91,43,91,42.3m-.07,3,7.92.51,7.93-.51-7.93-1.54L90.9,45.31M106.64,43l1.57-.19-1.57-.42V43",
    style: {
      fill: "#3c4929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,56l4.15,1L101,58.27V56",
    style: {
      fill: "#b7ca9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9,36.9V34.1l7.92-4,0,0,0,3.56h0l0,.09-4.33,1.75,0,6.16,2.31-.39,2.09-.42V66.09L96.45,64.9V61.55l-2.08-.84V45l-3.47.35v-2.8l-1.47.29V37.49l1.47-.59",
    style: {
      fill: "#4b612c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.73,41.34l-2.36.47v-6.3l2.36.74v5.09m6.2-9.15,3.82,1.91v2.8l1.46.59V42.8l-1.46-.29v2.8l-1.87-.18-1.6-.17v3.15h3.47V51l-1.61.14v2.91l-3.94.78v3.36L105.13,57v3l-3.94,1.57V64.9l-2.38,1.19V40.92l2.1.42,2.24.3V35.57l-4.28-1.66-.06-.18V30.14l4.11,2",
    style: {
      fill: "#759c3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.52,462.88H357.41L346.93,347.29c-.8-8.82-6.52-15.46-13.32-15.46H190.72c-8,0-14.25,9.17-13.31,19.59Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 757.32,
    y1: 148.26,
    x2: 912.94,
    y2: 86.13,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 769.72,
    y1: 199.57,
    x2: 928.68,
    y2: 273.22,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.91,
    y1: 152.65,
    x2: 260.66,
    y2: 77.75,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.15,
    y1: 173.17,
    x2: 100.32,
    y2: 170.23,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816,220a94.6,94.6,0,0,0-110-93.37A155.2,155.2,0,0,0,416,89.1c-3.47-.32-7-.51-10.54-.51a113,113,0,0,0-6.31,225.84v.18H727.76v-.23A94.63,94.63,0,0,0,816,220Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.46 484.75 635.23 484.75 634.36 480.3 634.36 449.33 660.59 449.33 660.59 480.07 661.46 484.75",
    style: {
      fill: "none",
      stroke: "#90bbc9",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.85,
    y: 427.91,
    width: 86.13,
    height: 95.11,
    style: {
      stroke: "#bce0fd",
      strokeMiterlimit: 10,
      strokeWidth: 10,
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "643.54 476 615.86 476.02 615.13 471.54 616.14 440.59 643.1 440.58 641.36 472.17 643.54 476",
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "643.97 476 617.74 476 616.87 471.55 616.87 440.58 643.1 440.58 643.1 471.32 643.97 476",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.8,
    y: 436.21,
    width: 3.5,
    height: 6.56,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.68,
    y1: 448.89,
    x2: 638.29,
    y2: 448.89,
    style: {
      stroke: "#bce0fd",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.68,
    y1: 452.39,
    x2: 638.29,
    y2: 452.39,
    style: {
      stroke: "#bce0fd",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.75,466s-18.61-31.09-19.89-46.88-10.76-34.59-14.15-35.07.84,15.25.84,15.25-6.54-4.08-9.44-3-13.5,9.27-13.5,9.27,2.42,2.7,3.63,2.45-7,2.17-3.63,4,8.72.8,8.72.8S723.84,423.28,726,423s5.33-7.3,5.33-7.3-.49,11.22,1.94,11,4.08,62.79,13.52,69.32,50.52-2.28,50.52-2.28l-18.44-27.36Z",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#g)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "773.31 461.21 781.19 510.36 797.33 500.37 797.33 475.06 773.31 461.21",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.8,426.06a30.62,30.62,0,0,0,7.41,1.67c2.86,0-2.15,63.09,34.62,72.88s-26.75,23.76-26.75,23.76l-27.45-33.32Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.35,415.74s3.51-11.47,5.9-8.08-6.68,15.39-6.68,15.39l.78-7.31",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.91,416.73s.79-9.79,4.62-11.82,6.64-3.37,8.89-1.68",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.39,408.18c.57-.11,5-6,10.81-7.66s8.78.12,8.78.12",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "474.77 578.92 453.73 588.43 426.23 519.85 454.42 515.22 474.77 578.92",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#h)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.1,519.09s-8.66,9.89-6.47,30,27.23,28,27.23,28l-9,18.72-29.51-10.89,1.43-69.09Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.93,518.7s-41.23-15.59-47.08,1.94,11.69,64.27,16.56,68.5,32.17-.22,32.17-.22Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,488s-29.66,10.51-31,19.4-2,45.18-2,45.18a104.74,104.74,0,0,0,19.58,3.27c9.33.45,17.16-21.58,17.16-21.58L387.7,545.75,362,552.58v35.94l89.65-.62-4.37-55.07L449.7,525l7.55-7.56S445.7,490.52,437,488.29s-21.28-2.66-21.28-2.66",
    style: {
      fill: "#14417d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#j)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 414.47,
    y1: 495.51,
    x2: 414.47,
    y2: 513.9,
    style: {
      fill: "#14417d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.08,
    cy: 503.34,
    r: 1.48,
    style: {
      fill: "#14417d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.08,
    cy: 508.65,
    r: 1.48,
    style: {
      fill: "#14417d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.21,537.07s37.85,55.61,38.87,55-34.8,3.24-35.41,2.45-15.24-12.18-14.74-13.4S361.21,537.07,361.21,537.07Z",
    style: {
      fill: "#0d2744",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "438.04 510.13 450.5 551.82 455.23 535.68 439.36 509.52",
    style: {
      fill: "#0d2744",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.98 517.25 419.21 561.39 448.25 574.75 395.2 573.22 398.77 534.27 393.98 517.25",
    style: {
      fill: "#0d2744",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.58,492.19s12.67,21.06,33.58,13.43,12.08-21.27,12.08-21.27",
    style: {
      fill: "none",
      stroke: "#0d2744",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.58,
    y1: 511.51,
    x2: 399.65,
    y2: 536.42,
    style: {
      fill: "none",
      stroke: "#0d2744",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.84,460.62s-13-4-11.82-14.89,9-13.84,9-13.84-5.8-5.44,2.24-9.34,18-8.86,27.79-2,24.12,3.79,22.11,13.13-12.06,8.86-12.06,8.86L405.83,463Z",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#k)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.93,442.52s26.86-5.19,31.9,3.51a16.28,16.28,0,0,1,0,17c-.61.89-22.59.23-22.59.23s-5-6.75-4.88-6.78S373.93,442.52,373.93,442.52Z",
    style: {
      fill: "#662a12"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.62,432.76s3.51-13.9,20.3-9.93,19.84.65,19.84.65",
    style: {
      fill: "none",
      stroke: "#662a12",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.66,432.14s7.19-7.67,16.11-5,21,3,23.57-2.5",
    style: {
      fill: "none",
      stroke: "#662a12",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,439.16s22-14.22,27.09-4.44-19.07,11.92-19.07,11.92l-8.69-7.94",
    style: {
      fill: "#662a12"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.86,439.1s3.9,15.37,3.43,24.24-3.08,14.43-9,15.61-5.67.59-5.67.59l.47,10.4,5.79,1.78s-3.31,12.77-14.18,10.76-19.63-8.87-19.63-8.87l4.26-3.78-.59-22.7s-12.54.47-12.42-8,6.62-9.94,10.88-7.22,6.38,7.92,6.38,7.92l3.08-.11.47-9.7s3.43-.84,3.19-3.31-3.54-7.57-3.54-7.57S421.59,431.06,427.86,439.1Z",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#l)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.84,479.23s-3.44.33-13.2-4.05c-.85-.38,1.54,24,5.28,30.53s15.5-9.31,16-10.08,3.05-10,3.05-10l-11.09-6.4",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08,470.68s13.7,13.4,28.12,6.89",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M406.16,449.69a6.46,6.46,0,0,1,1.18-2.59,8.09,8.09,0,0,1,2.08-2A11,11,0,0,1,412,443.9c.45-.15.9-.26,1.36-.38l1.38-.25a2,2,0,1,1,.72,4,2.12,2.12,0,0,1-.56,0h-.1l-1.07-.11c-.35,0-.71,0-1.06,0a8.37,8.37,0,0,0-2.06.34,6.31,6.31,0,0,0-1.84.95,5.06,5.06,0,0,0-1.36,1.57l-.06.1a.64.64,0,0,1-.86.27A.66.66,0,0,1,406.16,449.69Z",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.66,447.52a4.34,4.34,0,0,0-.86-.63,2.94,2.94,0,0,0-.94-.33,2.73,2.73,0,0,0-1.66.24,2.15,2.15,0,1,1-.47-4.07l.37.07a6.81,6.81,0,0,1,1.71.54,5.43,5.43,0,0,1,1.43,1,5.14,5.14,0,0,1,1,1.26,5.32,5.32,0,0,1,.59,1.43.64.64,0,0,1-.45.78.65.65,0,0,1-.6-.14Z",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.4,
    cy: 452.39,
    rx: 1.34,
    ry: 1.86,
    transform: "translate(-18.16 17.41) rotate(-2.34)",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 426.82,
    cy: 451.47,
    rx: 1.34,
    ry: 1.86,
    transform: "translate(-18.11 17.84) rotate(-2.34)",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.38,463s3.68,3.62,8.5,3.18c3.71-.34-1.43,5.18-4.14,4.45C412.93,469.31,412.29,465.1,413.38,463Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.61,448.31s3.17,6.08,4.65,9.44c1.36,3.08,2,4.8-3.06,3.49",
    style: {
      fill: "none",
      stroke: "#7c2b06",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493,571.31h-2.76a7.9,7.9,0,0,0-3.27,0c-2.55.3-3,1.13-3,1.13l-1.84.31c-1.84.31-6.23,3.17-6.23,3.17l-64.27-10.07-12.91-31.57-30.85,23.32,17,23a19.13,19.13,0,0,0,15.35,7.76l72.66.18v0c1.34,0,6.36.08,10.48,0,4.8-.1,4.08-5,6.84-4.49,2.54.47,0-2.34-.45-2.8.41.42,2.87,2.84,5.76,2.18,3.17-.71-.71-3.47-.71-3.47s7.56,3.06,9.29,2.35-3.55-5.52-3.55-5.52,6.62-.2,7.54-3S493,571.31,493,571.31Z",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#m)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.54,534.27s-27.27,18.6-18.72,34.68,48.55,16.33,66.52,14.78,34,6.24,37.47,4.79.82,5.05.82,5.05-79.58,13.43-81.81,13S361,593.57,360,589.3s-1.63-39.12-1.22-39.71,17.39-10.36,20-11.17,24.58-8.14,24.58-8.14Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.35,
    y1: 561.39,
    x2: 404.56,
    y2: 572.99,
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.13,578.71s5.81-2.85,7.58-1.62l7.48,5.13",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.87,578.31s-7.73-6.16-9.36-5.32-8.14,1.45-8.14,1.45",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "482.91 582.22 490.68 582.22 492.88 584.92",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "543.97 535.68 572.22 583.73 543.97 583.73",
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 15,
      stroke: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.83,401.9s-14.93-19.52-6.17-28.28c10.54-10.54,21.08-1,41.13-5.14s34.57,26.49,30.72,33.94,0,18.56-27.9,34.7",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#o)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M832.17,397.1s0-7.68.59-9.11c1-2.35,2.22,8.74,33.65,8.13s34.4,2.49,32.41,14S887.92,443,887.92,443s-13.16,5.38-14,5-35.08-28.88-34.67-30.3S832.17,397.1,832.17,397.1Z",
    style: {
      fill: "#662a12"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M876.59,454.5s30.81,12.24,32.4,22.88,1.28,44.88,1.28,44.88-4.64-7.27-15.81-6.74-15.29,1.75-15.29,1.75l1.44,6,24.76,29,.76,48.26-96.23.34-.67-93.05-2.85-9.44-9-9.05s13.83-32.18,24.21-34.84a111.5,111.5,0,0,1,17.2-3.19",
    style: {
      fill: "#882c7b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#p)"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "891.41 521.22 876.93 484.63 871.54 530.28 891.41 545.17 887.98 519.6",
    style: {
      fill: "#6d1b65",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.27,524s4.63,12.1,22,16.28,48,43,62.46,33.27,11.4-33,11.4-33l-13.26-15.59s-39.2,10.69-50.24-1.86S817.27,524,817.27,524Z",
    style: {
      fill: "#6d1b65",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 848.55,
    y1: 463.14,
    x2: 848.55,
    y2: 485.16,
    style: {
      fill: "none",
      stroke: "#6d1b65",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855.01,
    cy: 472.52,
    r: 1.77,
    style: {
      fill: "#6d1b65",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855.01,
    cy: 478.88,
    r: 1.77,
    style: {
      fill: "#6d1b65",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 877.28,
    y1: 494.69,
    x2: 879.49,
    y2: 521.46,
    style: {
      fill: "none",
      stroke: "#6d1b65",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M830,392.69s-2.87,13.15-1.54,24.86.9,20.82,10.51,22.22c4.11.6,5.32,0,5.32,0l-.54,9.57-7.2,3.2s5.34,15,19.17,12.82,20.48-10.43,20.48-10.43l-6.11-4.26,1.86-25s10.39-3.44,9.86-10.36-7.82-14-14.12-4.74c-4.49,6.58-.23,9.38-5.47,9.74l-.26-4-.06-6s-4.56-6-5.53-7.71c-1.85-3.25,1.35-5.59-10.09-5.85S830,392.69,830,392.69Z",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#q)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.93,419.19c.87-4.27-2.3-3.36-2.27-3.6a4.45,4.45,0,0,1,4.78-4.11c4.72.1,7.09,5.06,2.14,8.44C874,421,870.61,420.8,870.93,419.19Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.93,418.31s4.21-3-1.23-6.11-7,3.39-7,3.39,3.27,1,2.27,3.6",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.78,412.87s2,3.18,4,2.93",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.65,439.18s16.84,4.26,23.26-5.58",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.21,440.7s17.39,1,20.6-8.6c0,0-4.79,21.2-16.68,17.77",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M837.58,519.6h-40a3.64,3.64,0,0,1-3.38-2.84L779.28,463c-.74-2.64,1-5.35,3.38-5.35h35.6a7.43,7.43,0,0,1,6.85,5.57l15.81,50.87C841.75,516.79,840,519.6,837.58,519.6Z",
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.65,519.6h-40a3.64,3.64,0,0,1-3.38-2.84L775.35,463c-.73-2.64,1-5.35,3.38-5.35h35.6a7.42,7.42,0,0,1,6.85,5.57L837,514.12C837.83,516.79,836.11,519.6,833.65,519.6Z",
    style: {
      fill: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.14,520.09s2.13,30.32-3.19,35.11-11.71,7.71-21.55,2.93S841,529.67,841,529.67s-10.1,4.79-18.35,2.39-19.68-12.5-20.21-15.42l-.53-2.93s-.78-2.84.21-3.59a3.85,3.85,0,0,1,1.9-.8s-.6-4.49,1.44-4.74a9.77,9.77,0,0,1,4.39.8s.5-3,3.14-2.64a18.66,18.66,0,0,1,5.54,2.09s9,10.87,13.76,10.08a8.23,8.23,0,0,0,6.29-4.39l-.8-6.49s2.69-.59,5.88,2.5a90.93,90.93,0,0,0,15.83,12.1c5.72,3.19,20.21,7.31,20.21,7.31l-.4-9S897.64,504.67,910.14,520.09Z",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#s)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.89,513.71s5.61,8.51,12.9,10.76",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.47,507.49s1.47,8,11.39,12.56",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.43,503.07s1.54,9.3,13.48,15.19",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.27,508.73s8.45,8.22,8.3,14.11",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896,539.74a133.33,133.33,0,0,0-18.91-15.27",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.09,525.64s-18-7.56-21.34-5.31,4.25,18.9,4.25,18.9l-18.16-13.8V512.37s8.28-4.68,9.66-5.21,15.82,2,16.14,2,8.18,9.66,8.18,9.66Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.85,553.92l.69.2c4.64,1.32,31.28,8.33,37-3,6.23-12.45,8.21-14.86,8.21-14.86l4.5,27.54s-23.61,11.39-24.46,11.53-10.9-3.25-13-5.8S872.85,553.92,872.85,553.92Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.57,530.9s19.65-1.12,26-2.68S866.55,549,866.55,549Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M854.51,408a5.34,5.34,0,0,0-1.45-1.71,6.48,6.48,0,0,0-2-1.06,9.15,9.15,0,0,0-2.22-.4c-.38,0-.77,0-1.15,0l-1.16.1h-.1a2,2,0,1,1-.37-4,3.09,3.09,0,0,1,.53,0l1.47.26c.49.13,1,.23,1.45.39a11.73,11.73,0,0,1,2.75,1.3,8.72,8.72,0,0,1,2.22,2.06,6.81,6.81,0,0,1,1.27,2.75.64.64,0,0,1-1.2.42Z",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.39,404.78a5.9,5.9,0,0,1,.64-1.5A5.75,5.75,0,0,1,831.1,402a5.64,5.64,0,0,1,1.52-1,6.68,6.68,0,0,1,1.8-.54l.3-.06a2.12,2.12,0,1,1,.78,4.17,2,2,0,0,1-1.18-.12,3.15,3.15,0,0,0-1.84-.2,3.4,3.4,0,0,0-1,.39,5,5,0,0,0-.91.71l-.11.1a.64.64,0,0,1-1.06-.64Z",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 844.82,
    cy: 410.57,
    rx: 1.99,
    ry: 1.44,
    transform: "translate(400.04 1237.88) rotate(-87.66)",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 833.65,
    cy: 409.57,
    rx: 1.99,
    ry: 1.44,
    transform: "translate(390.32 1225.77) rotate(-87.66)",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.06,421.93s-3.94,3.88-9.12,3.41c-4-.37,1.54,5.56,4.45,4.77C848.54,428.71,849.23,424.19,848.06,421.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.22,406.19s-3.4,6.52-5,10.12c-1.46,3.31-2.13,5.14,3.28,3.74",
    style: {
      fill: "none",
      stroke: "#7c2b06",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885,377.81s21.29,8.42,9.19,27.24",
    style: {
      fill: "none",
      stroke: "#7c2b06",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.9,377.81s-2.25,15.86,26.9,17.17S885,413.36,885,413.36",
    style: {
      fill: "none",
      stroke: "#662a12",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.51,378.51s-.82,11.27,24.42,14.18",
    style: {
      fill: "none",
      stroke: "#662a12",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36,349.13S223.94,367,225.57,391.28",
    style: {
      fill: "none",
      stroke: "#7c2b06",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.34,330.78s-3.16,2.28-22.67,33.64c-10.36,16.66,7.89,69.07,7.89,69.07l64.6-20.92,16.21-19.7s-17.89-18.38-14-53.21",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#t)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.81,317.12s11.95,22.77,27,26.32,32.33-3,32.33-3-19.56,12.39-12.92,24.44S262.5,367,262.5,367s9.32-17,3.15-24.25-17.43-21.76-10.9-26.42",
    style: {
      fill: "#662a12"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.22,398.1l-6.74,15.72L180.32,379.4s-1.87-21.7-6-23.19-6.35,3.92-6.35,3.92S157.13,342.36,154.51,345s4.49,18,4.49,18-3-3-5.07,1.12,0,6,0,6-3.72,0-3.3,2.85a6.72,6.72,0,0,0,1.68,3.93s-3.65,3.51-.7,5.19,9.82,8.13,16.13,9.54,23.11,46.38,47.84,59.48c11.13,5.89,28.34-21.33,28.34-21.33l4.77-30.86Z",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#u)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.16,401.63s14.55-.14,15,13.74S236.19,455,236.19,455l21.1-28.19V396.61S215.58,392.14,214.16,401.63Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.27,386.79s4.77-.65,5.6-4.66.83-8.16,2.5-7.95,3.74-.68,6.23-4,7.9,24.91,16.62,37.2,21.2,44.93,21.2,44.93l-39.48-22.19-12.67-43.35",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.16,
    y1: 408.47,
    x2: 218.38,
    y2: 426.34,
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,367.91S163,380.83,164,377.09s-3.43-11.33-3.43-11.33",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.09,376.2c.26,0,9.25,8.41,11,7.17s.32-4.41.32-4.41",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,361.5s-3.22,12.7.93,10.7,5.93-7.37,5.93-7.37",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,319.72s7.17-14.57-16.12-26.49c-16-8.19-41.29,1.88-42,28.36-.25,9.09,7.18,14.5,14.59,21.78,17,16.65,9,15.95,16.85,22.24s-6.33,6-6.33,6l4.13-20.23s30.3-3.84,18.08,1.11C295.69,355.56,314.2,319.72,314.2,319.72Z",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#v)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.16,289.72c.91.33,17.52,17.54,14.38,26.56s18.85,16.65,20.19,14.93.56-20.85.26-25.22-9.73-14.15-10.22-14.28S296.16,289.72,296.16,289.72Z",
    style: {
      fill: "#662a12"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.67,463.66s5.89-18.51,0-24.13-5.33-10.66-4.21-21.6,2-12.62,2-12.62-3.37-4.49-11-4.21a79,79,0,0,1-10.1,0s5.05-23.55,24.69-28.32,29.68-11.82,29.68-11.82,19.42,2.56,28.12,2.84,19.64-2.24,25.25,5.33,1.4,28.62,1.4,28.62l-23.28-1.12,14.87,67.05Z",
    style: {
      fill: "#ffd731"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#w)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.24,396.61s-14.31,28.88-18.74,34.29,5,40,5,40,30.8.58,32.86,0,17.21-12.07,17.21-12.07l-3.16-36.33-22.15-25.11Z",
    style: {
      fill: "#efb43f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.36,433.49s1.66,7.19,11.22,8.23,2.11,27.43,2.11,27.43l-15.2-6.27",
    style: {
      fill: "#efb43f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,370.34a61,61,0,0,0,28.86-.58c15.82-4.17,50.63-3.74,57.69-7s2.4-5.89,2.4-5.89l-47.71-18.37-39.33,21.07Z",
    style: {
      fill: "#efb43f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.86,
    y1: 382.13,
    x2: 301.81,
    y2: 405.57,
    style: {
      fill: "none",
      stroke: "#efb43f",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.28,409.82s9.66-20.89,15.12-23.69",
    style: {
      fill: "none",
      stroke: "#efb43f",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "327.52 397.73 311.16 463.66 286.09 463.66 304.24 396.61 327.52 397.73",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#x)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.38,397s21-.7,18.48,9.1-16.12,67.95-16.12,67.95l28.11-4.49,15-74.25S301.27,388.91,299.38,397Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.22,328.2s-8.65-13-14.71-4.61.94,13.92,5.21,14.53,3.3.34,3.3.34l-6.57,26.14-8.78,7a37.56,37.56,0,0,0,24.55,10.87c15.43.73,17.31-13,17.31-13l-7.08-1.87-1.75-12.13s6.92,3,13.74-5,6.76-30.71,6.76-30.71l-3.3-8.14c-2.94,3.69-11.34,7.78-15.62,9.75C291.93,322.88,282.22,328.2,282.22,328.2Z",
    style: {
      fill: "#ffad94"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#y)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.62,331.53s-4.47-2.73.83-6.27,7.35,2.95,7.35,2.95-3.24,1.18-2.06,3.8",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.47,325.61s-1.79,3.35-3.86,3.23",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.1,358.33s-12.63-3.57-18.59-9.09",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.84,365.18s-13.81-5-14.72-16.27a35.78,35.78,0,0,0,12.2,6.89C296.64,356.5,296.84,365.18,296.84,365.18Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,332c-1.17-4.26,2.11-3.56,2.06-3.8a4.51,4.51,0,0,0-5.12-3.83c-4.77.42-6.82,5.61-1.59,8.68C273.75,334,277.18,333.62,276.74,332Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.77,324.42a10.8,10.8,0,0,1,2.06-1.33,11.33,11.33,0,0,1,2.33-.84,9.19,9.19,0,0,1,2.52-.26,10.12,10.12,0,0,1,2.55.4,1,1,0,0,1-.51,1.95l-.13,0-.06,0a8.09,8.09,0,0,0-2-.62,7.7,7.7,0,0,0-2.15-.09,9.64,9.64,0,0,0-2.16.44,10.17,10.17,0,0,0-2,.92l0,0a.34.34,0,0,1-.45-.11A.32.32,0,0,1,292.77,324.42Z",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86,325.92a5,5,0,0,0-1-.75,6.14,6.14,0,0,0-1.12-.49,5.9,5.9,0,0,0-2.35-.21,1,1,0,1,1-.22-2h.27a7.48,7.48,0,0,1,2.86,1,6.12,6.12,0,0,1,1.17.91,5.49,5.49,0,0,1,.91,1.16.32.32,0,0,1-.12.44.33.33,0,0,1-.39-.05Z",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.76,
    cy: 328.53,
    rx: 2.02,
    ry: 1.46,
    transform: "translate(-73.09 571.25) rotate(-80.85)",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.06,
    cy: 329.8,
    rx: 2.02,
    ry: 1.46,
    transform: "matrix(0.16, -0.99, 0.99, 0.16, -64.84, 583.48)",
    style: {
      fill: "#7c2b06"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,330.91s-.63-.05.64,4c1.17,3.68,1.19,6.36-5.49,3.6",
    style: {
      fill: "none",
      stroke: "#7c2b06",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.3,340.87a106.43,106.43,0,0,0,10.91,4C305.16,345.1,292.43,355.65,293.3,340.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.69,
    cy: 336.1,
    r: 4.18,
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.35,319.89s19-3.07,23.58-16.22",
    style: {
      fill: "none",
      stroke: "#662a12",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,295.44s-30.52,2.12-25.8,31.36",
    style: {
      fill: "none",
      stroke: "#662a12",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.45,367.92s16.07-17.79,17.68-27.66",
    style: {
      fill: "none",
      stroke: "#662a12",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.75,
    cy: 338.35,
    r: 2.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.5 553.6 654.78 587.47 622.9 587.47 629.84 553.6 665.5 553.6",
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.42,554.2H597a4.45,4.45,0,0,1-4.39-3.81l-8.82-62a4.43,4.43,0,0,1,4.38-5.06H683.3a4.44,4.44,0,0,1,4.36,3.65l11.12,62A4.43,4.43,0,0,1,694.42,554.2Z",
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.05,554.2H603.21a5.75,5.75,0,0,1-5.69-4.94l-9.39-65.9h99.24a5.65,5.65,0,0,1,5.56,4.66l10.69,59.52A5.66,5.66,0,0,1,698.05,554.2Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#aa)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "704.81 540.21 593.96 540.21 583.47 469.38 691.59 469.38 704.81 540.21",
    style: {
      fill: "#14417d"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 611.49,
    y: 581.26,
    width: 57.53,
    height: 6.88,
    style: {
      fill: "url(#ab)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 658.86,
    cy: 546.85,
    rx: 3.16,
    ry: 3.51,
    transform: "translate(-191.33 648.5) rotate(-46.51)",
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.24,566.62H716V562.2H691v19.7a7.08,7.08,0,0,0,7.08,7.08H708.9a7.08,7.08,0,0,0,7.08-7v-2.37h1.26a5,5,0,0,0,5-5.05v-2.85A5,5,0,0,0,717.24,566.62Zm3.68,7.9a3.69,3.69,0,0,1-3.68,3.69H716V568h1.26a3.68,3.68,0,0,1,3.68,3.68Z",
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.07,559.67s1.47-2.14-1.5-8.39-6.34-3.93,1.86-11.24,4.12-16.61,0-20.89c0,0,15,6.16,8.39,17.32s4.16,5.17,1.83,14.46C712,557.7,703.07,559.67,703.07,559.67Z",
    style: {
      fill: "#bce0fd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "329.81 531.4 320.9 523.84 298.14 551.39 298.14 586.12",
    style: {
      fill: "none",
      stroke: "#bce0fd",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.14,
    cy: 552.58,
    r: 2.99,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.6,
    cy: 524,
    r: 3.61,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.77,
    y: 584.92,
    width: 29.94,
    height: 7.19,
    rx: 3.4,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.93,528.88l-18,22.76s-15.57-10.78-6-24C334.4,516.1,349.93,528.88,349.93,528.88Z",
    style: {
      fill: "#8cbdf2"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340.9,
    cy: 540.22,
    rx: 14.5,
    ry: 2.4,
    transform: "translate(-294.92 478.7) rotate(-52.22)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.69,465.9h.68a12,12,0,0,1,12,12v91.61a12,12,0,0,1-12,12h-.68a0,0,0,0,1,0,0V465.9A0,0,0,0,1,540.69,465.9Z",
    transform: "translate(226.82 -162.57) rotate(21.23)",
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.48,
    y: 588.52,
    width: 498.48,
    height: 12.1,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.16,
    cy: 427.91,
    r: 25.41,
    style: {
      stroke: "#bce0fd",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "url(#ac)"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "549.16 411.38 549.16 427.9 562.48 427.9",
    style: {
      stroke: "#bce0fd",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      fill: "url(#ad)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.58,462c-.76-3.76,2-3,2-3.17a3.91,3.91,0,0,0-4.2-3.61c-4.15.09-6.23,4.46-1.89,7.42C387.87,463.58,390.87,463.41,390.58,462Z",
    style: {
      fill: "#f78272",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.31,461.22s-3.71-2.62,1.08-5.38,6.19,3,6.19,3-2.87.84-2,3.17",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.72,456.44s-1.75,2.79-3.53,2.57",
    style: {
      fill: "none",
      stroke: "#f78272",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.44,165.64a17.69,17.69,0,0,0,.64,5.2A31.65,31.65,0,0,0,510,175a2.58,2.58,0,0,1,.41,1.34,2.32,2.32,0,0,1-1.11,1.76l-3.68,2.45a2.8,2.8,0,0,1-1.52.52,2.7,2.7,0,0,1-1.75-.81,17.6,17.6,0,0,1-2.1-2.75c-.58-1-1.17-2.1-1.81-3.44a21.55,21.55,0,0,1-17.16,8c-4.91,0-8.82-1.4-11.68-4.2s-4.32-6.54-4.32-11.21a15,15,0,0,1,5.31-12c3.56-3,8.29-4.56,14.31-4.56a46.5,46.5,0,0,1,6.18.47c2.16.29,4.38.76,6.72,1.28v-4.26c0-4.43-.94-7.53-2.75-9.34s-5-2.68-9.51-2.68a26.39,26.39,0,0,0-6.31.76,45.18,45.18,0,0,0-6.3,2,18.17,18.17,0,0,1-2,.76,3.4,3.4,0,0,1-.94.17c-.82,0-1.22-.58-1.22-1.81v-2.86a3.72,3.72,0,0,1,.4-2,4.34,4.34,0,0,1,1.64-1.22,33,33,0,0,1,7.35-2.63,35.37,35.37,0,0,1,9.11-1.11c6.95,0,12,1.58,15.3,4.73s4.84,7.94,4.84,14.36v18.91Zm-23.7,8.88a18.94,18.94,0,0,0,6-1.05,13.16,13.16,0,0,0,5.55-3.74,9.33,9.33,0,0,0,2-3.74,21,21,0,0,0,.58-5.08v-2.45a47.43,47.43,0,0,0-5.37-1,44.44,44.44,0,0,0-5.48-.35c-3.92,0-6.78.76-8.7,2.33a8.14,8.14,0,0,0-2.86,6.72c0,2.74.7,4.79,2.16,6.19S481.05,174.52,483.74,174.52Zm46.87,6.3a3.22,3.22,0,0,1-2.21-.58,4.74,4.74,0,0,1-1.23-2.28l-13.72-45.13a10,10,0,0,1-.52-2.33,1.28,1.28,0,0,1,1.4-1.46h5.72a3.25,3.25,0,0,1,2.27.58,4.76,4.76,0,0,1,1.17,2.28l9.81,38.65,9.11-38.65a4.07,4.07,0,0,1,1.11-2.28,4,4,0,0,1,2.33-.58h4.67a3.58,3.58,0,0,1,2.34.58A4,4,0,0,1,554,131.9L563.19,171l10.1-39.11a5,5,0,0,1,1.17-2.28,3.78,3.78,0,0,1,2.27-.58h5.43a1.3,1.3,0,0,1,1.46,1.46,5.65,5.65,0,0,1-.12.93,7.69,7.69,0,0,1-.4,1.46L569,178a4.45,4.45,0,0,1-1.23,2.28,3.73,3.73,0,0,1-2.22.58h-5a3.53,3.53,0,0,1-2.33-.58,4.11,4.11,0,0,1-1.11-2.34l-9-37.65-9,37.59a4.53,4.53,0,0,1-1.11,2.34,3.62,3.62,0,0,1-2.34.58Zm75,1.58a38.64,38.64,0,0,1-9-1.05,26.19,26.19,0,0,1-6.71-2.34,4.15,4.15,0,0,1-1.81-1.63,4,4,0,0,1-.35-1.64v-3c0-1.22.46-1.8,1.34-1.8a3.21,3.21,0,0,1,1,.17c.35.12.88.35,1.46.58a31.5,31.5,0,0,0,6.42,2,35.62,35.62,0,0,0,7,.7c3.68,0,6.54-.64,8.52-1.93a6.27,6.27,0,0,0,3-5.54A5.69,5.69,0,0,0,615,162.9c-1.05-1.11-3-2.1-5.9-3l-8.46-2.62c-4.26-1.35-7.41-3.33-9.34-6a13.89,13.89,0,0,1-2.92-8.46,13,13,0,0,1,1.58-6.48,15,15,0,0,1,4.2-4.79,18.81,18.81,0,0,1,6.07-3,25.51,25.51,0,0,1,7.36-1,28.6,28.6,0,0,1,3.91.24c1.34.17,2.57.4,3.79.64s2.28.58,3.33.93a12.64,12.64,0,0,1,2.45,1,5.11,5.11,0,0,1,1.75,1.46,3.16,3.16,0,0,1,.53,1.93v2.74c0,1.23-.47,1.87-1.34,1.87a6,6,0,0,1-2.22-.7,26.7,26.7,0,0,0-11.21-2.28c-3.33,0-6,.53-7.77,1.64a5.63,5.63,0,0,0-2.74,5.19,5.51,5.51,0,0,0,1.75,4.15,17.43,17.43,0,0,0,6.42,3.21l8.29,2.63c4.21,1.34,7.24,3.21,9,5.6a13.21,13.21,0,0,1,2.69,8.17,15,15,0,0,1-1.52,6.77,15.63,15.63,0,0,1-4.26,5.14,18.83,18.83,0,0,1-6.48,3.27A27.69,27.69,0,0,1,605.63,182.4Z",
    style: {
      fill: "#252f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.66,210.77c-19.2,14.18-47.11,21.72-71.1,21.72a128.63,128.63,0,0,1-86.81-33.11c-1.81-1.63-.17-3.85,2-2.56a175.05,175.05,0,0,0,86.86,23.06,173.29,173.29,0,0,0,66.26-13.55C617.07,204.87,619.82,208.43,616.66,210.77Z",
    style: {
      fill: "#f90",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.66,201.66c-2.45-3.15-16.23-1.52-22.47-.76-1.87.24-2.16-1.4-.47-2.62,11-7.71,29-5.49,31.11-2.92S632.25,216,622,224.66c-1.58,1.35-3.1.64-2.4-1.11C621.92,217.77,627.11,204.76,624.66,201.66Z",
    style: {
      fill: "#f90",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,407.43c1.2-1.14,13.43-23.49,13.43-23.49s-17.88,16.42-17.87,20.58S237.93,407.43,237.93,407.43Z",
    style: {
      fill: "#efb43f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 804.64,
    cy: 486.53,
    rx: 7.65,
    ry: 9.01,
    transform: "translate(-127.13 360.18) rotate(-23.44)",
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 848.45,
    cy: 409.37,
    r: 8.71,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 831.06,
    cy: 408.54,
    rx: 5.16,
    ry: 7.67,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 866.55,
    y1: 410.57,
    x2: 857.15,
    y2: 409.75,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.73,408.22s-2.34-1-3.51,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.6,
    cy: 295.04,
    r: 39.91,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.6,
    cy: 295.04,
    r: 39.91,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 947.88,
    cy: 70.27,
    r: 39.91,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.91,
    cy: 170.52,
    r: 39.91,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.05,
    cy: 47.3,
    r: 39.91,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,176.89A14.62,14.62,0,0,0,72.82,152l-.4,0-.4,0a16.09,16.09,0,0,0-5.75-5.78,15.89,15.89,0,0,0-16.82.45,16,16,0,0,0-5.75,6.74A13.93,13.93,0,0,0,34.24,177",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.38,
    cy: 171.96,
    r: 0.98,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.29,
    cy: 171.96,
    r: 0.98,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.38,
    cy: 178.8,
    r: 0.98,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.29,
    cy: 178.8,
    r: 0.98,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.38,
    cy: 185.63,
    r: 0.98,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.29,
    cy: 185.63,
    r: 0.98,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3,
    y: 175.38,
    width: 25.4,
    height: 6.84,
    rx: 3,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3,
    y: 168.54,
    width: 25.4,
    height: 6.84,
    rx: 3,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.3,
    y: 182.22,
    width: 25.4,
    height: 6.84,
    rx: 3,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.27,
    cy: 177.99,
    r: 20.64,
    style: {
      fill: "none",
      stroke: "#ff8015",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.78,
    y1: 192.49,
    x2: 73.77,
    y2: 163.5,
    style: {
      fill: "none",
      stroke: "#ff8015",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 965.81,
    cy: 276.39,
    rx: 17.47,
    ry: 4.85,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.28,287.07c0,2.68-7.82,4.85-17.47,4.85s-17.47-2.17-17.47-4.85",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.28,297.75c0,.67-.49,1.3-1.37,1.89a13.68,13.68,0,0,1-3.74,1.54,38.18,38.18,0,0,1-5.56,1,61,61,0,0,1-13.6,0",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.93,312.18c1.25.08,2.55.12,3.88.12,9.65,0,17.47-2.17,17.47-4.85V276.39",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 948.34,
    y1: 276.39,
    x2: 948.34,
    y2: 296.78,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.78,
    cy: 286.1,
    r: 0.97,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978.64,
    cy: 285.31,
    r: 0.97,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.78,
    cy: 296.78,
    r: 0.97,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978.64,
    cy: 295.98,
    r: 0.97,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 974.78,
    cy: 306.48,
    r: 0.97,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978.64,
    cy: 305.69,
    r: 0.97,
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.37,311.82l-1.94-1.12a10.73,10.73,0,0,0,.11-1.51,10.84,10.84,0,0,0-.11-1.51l1.94-1.12a1.06,1.06,0,0,0,.39-1.45l-3-5.1a1.11,1.11,0,0,0-.64-.5,1.08,1.08,0,0,0-.81.11l-1.94,1.12a10.63,10.63,0,0,0-2.61-1.51V297a1.06,1.06,0,0,0-1.07-1.06h-5.89a1.05,1.05,0,0,0-1.06,1.06v2.24a10.88,10.88,0,0,0-2.62,1.51l-1.93-1.12a1.1,1.1,0,0,0-.81-.11,1.13,1.13,0,0,0-.65.5l-2.94,5.1a1.05,1.05,0,0,0,.39,1.45l1.93,1.12a11.45,11.45,0,0,0,0,3l-1.93,1.12a1.07,1.07,0,0,0-.39,1.46l2.94,5.1a1.07,1.07,0,0,0,.65.49,1.09,1.09,0,0,0,.81-.1l1.93-1.12a11.22,11.22,0,0,0,2.62,1.51v2.23a1.06,1.06,0,0,0,1.06,1.07h5.89a1.07,1.07,0,0,0,1.07-1.07v-2.23a11,11,0,0,0,2.61-1.51l1.94,1.12a1,1,0,0,0,.81.1,1.05,1.05,0,0,0,.64-.49l3-5.1A1.08,1.08,0,0,0,962.37,311.82ZM949.8,315a5.82,5.82,0,1,1,5.81-5.82A5.82,5.82,0,0,1,949.8,315Z",
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 955.25,
    y1: 67.49,
    x2: 961.77,
    y2: 63.77,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 962.7,
    y1: 78.65,
    x2: 955.25,
    y2: 74.93,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 948.82,
    y1: 85.41,
    x2: 948.74,
    y2: 77.72,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 948.82,
    y1: 64.94,
    x2: 948.74,
    y2: 57.25,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 942.23,
    y1: 67.49,
    x2: 934.79,
    y2: 63.77,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 934.79,
    y1: 78.65,
    x2: 942.23,
    y2: 74.93,
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.56,73.26l-1.51-.87a8.74,8.74,0,0,0,0-2.36l1.51-.87a.83.83,0,0,0,.3-1.14l-2.3-4a.85.85,0,0,0-.5-.39.81.81,0,0,0-.63.08l-1.51.88a8.4,8.4,0,0,0-2-1.18V61.68a.83.83,0,0,0-.83-.83h-4.6a.83.83,0,0,0-.83.83v1.75a8.16,8.16,0,0,0-2,1.18l-1.52-.88a.82.82,0,0,0-.63-.08.85.85,0,0,0-.5.39l-2.3,4a.84.84,0,0,0,.3,1.14l1.51.87a8.74,8.74,0,0,0,0,2.36l-1.51.87a.84.84,0,0,0-.3,1.14l2.3,4a.85.85,0,0,0,.5.39.82.82,0,0,0,.63-.08l1.52-.88a8.16,8.16,0,0,0,2,1.18v1.75a.83.83,0,0,0,.83.83H951a.83.83,0,0,0,.83-.83V79a8.4,8.4,0,0,0,2-1.18l1.51.88a.81.81,0,0,0,.63.08.85.85,0,0,0,.5-.39l2.3-4A.83.83,0,0,0,958.56,73.26Zm-9.82,2.49a4.54,4.54,0,1,1,4.54-4.54A4.54,4.54,0,0,1,948.74,75.75Z",
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "968.28 67.67 961.77 63.77 961.77 57.25 968.28 61.16 968.28 67.67",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "974.79 63.77 968.28 67.67 968.28 61.16 974.79 57.25 974.79 63.77",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "968.28 53.35 961.77 57.25 968.28 61.16 974.79 57.25 968.28 53.35",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "968.28 88.14 961.77 84.23 961.77 77.72 968.28 81.63 968.28 88.14",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "974.79 84.23 968.28 88.14 968.28 81.63 974.79 77.72 974.79 84.23",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "968.28 73.81 961.77 77.72 968.28 81.63 974.79 77.72 968.28 73.81",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "929.2 67.67 922.69 63.77 922.69 57.25 929.2 61.16 929.2 67.67",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "935.72 63.77 929.2 67.67 929.2 61.16 935.72 57.25 935.72 63.77",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "929.2 53.35 922.69 57.25 929.2 61.16 935.72 57.25 929.2 53.35",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "929.2 88.14 922.69 84.23 922.69 77.72 929.2 81.63 929.2 88.14",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "935.72 84.23 929.2 88.14 929.2 81.63 935.72 77.72 935.72 84.23",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "929.2 73.81 922.69 77.72 929.2 81.63 935.72 77.72 929.2 73.81",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "948.74 99.31 942.23 95.4 942.23 88.89 948.74 92.79 948.74 99.31",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "955.25 95.4 948.74 99.31 948.74 92.79 955.25 88.89 955.25 95.4",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "948.74 84.98 942.23 88.89 948.74 92.79 955.25 88.89 948.74 84.98",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "948.74 57.44 942.23 53.53 942.23 47.02 948.74 50.93 948.74 57.44",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "955.25 53.53 948.74 57.44 948.74 50.93 955.25 47.02 955.25 53.53",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "948.74 43.11 942.23 47.02 948.74 50.93 955.25 47.02 948.74 43.11",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.05,21.75l-27,15s1,27,27,41c26-14,27-41,27-41Z",
    style: {
      fill: "none",
      stroke: "#294364",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.05,31.75a6.82,6.82,0,0,0-6.81,6.82v4.09h-2.73a2.73,2.73,0,0,0-2.73,2.73V59a2.72,2.72,0,0,0,2.73,2.72H245.6A2.72,2.72,0,0,0,248.33,59V45.39a2.73,2.73,0,0,0-2.73-2.73h-2.73V38.57A6.83,6.83,0,0,0,236.05,31.75ZM232,38.57a4.09,4.09,0,1,1,8.18,0v4.09H232Zm5.46,14.62v4.47h-2.73V53.19a2.72,2.72,0,1,1,4-2.94,3,3,0,0,1,.06.59A2.71,2.71,0,0,1,237.42,53.19Z",
    style: {
      fill: "#ff8015"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.2,34.68l-2.38-1-4.45,1.78,2.36.74,4.47-1.57",
    style: {
      fill: "#3c4929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37,35.51l4.45-1.78.94.38,1.44.57,2.08.84-.11.11-2.12.66-.13,0-2.1-.74-2.09.74-2.36-.74",
    style: {
      fill: "#3c4929"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.92,36.25l2.36-.73v6.3l-2.36-.48V36.25",
    style: {
      fill: "#4b612c"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.73,
    y1: 200.64,
    x2: 113.43,
    y2: 222.53,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.98,
    cy: 241.13,
    r: 24.89,
    style: {
      fill: "none",
      stroke: "#fd8015",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.59,251.56l-3.36.77V230.61l3.36.77v20.18",
    style: {
      fill: "#f68536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77,252.85,119.59,254v-25.1l4.18,1.18v22.73m5.37,1.31-5.37,2V226.84l5.37,2v25.35m14.35-2.53-14.35,7.18V224.16l14.35,7.17v20.3",
    style: {
      fill: "#f68536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.28,225.59l2.86-1.43v34.65l-2.86-1.43V225.59M121.56,228l2.21-1.11v29.28L121.56,255V228m-3.74,1.87,1.77-.89V254l-1.77-.88V229.82m-1.59.79-1.44.72v20.3l1.44.72V230.61",
    style: {
      fill: "#9d5025"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.53,
    y: 319.89,
    width: 83.57,
    height: 48.95,
    rx: 10.17,
    transform: "translate(1502.62 688.73) rotate(-180)",
    style: {
      fill: "#ffd731"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.16,351.42S797.35,375,810.72,375c0,0-22.22,6.52-30.8-10.64",
    style: {
      fill: "#ffd731"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.57,
    cy: 344.36,
    r: 3.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751.31,
    cy: 344.36,
    r: 3.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 735.05,
    cy: 344.36,
    r: 3.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.25,
    y: 327.66,
    width: 70.98,
    height: 78.6,
    rx: 11.66,
    style: {
      fill: "url(#ae)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.61,
    y: 355.04,
    width: 44.28,
    height: 5.58,
    rx: 2.79,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.61,
    y: 367.03,
    width: 44.28,
    height: 5.58,
    rx: 2.79,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.61,
    y: 343.04,
    width: 44.28,
    height: 5.58,
    rx: 2.79,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.61,
    y: 379.9,
    width: 23.95,
    height: 5.58,
    rx: 2.79,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.33,
    cy: 403.11,
    r: 20.33,
    style: {
      fill: "#00bac6"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "476.53 406.58 484.72 412.17 496.54 397.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.37,
    y: 299.14,
    width: 70.98,
    height: 78.6,
    rx: 11.66,
    style: {
      fill: "url(#af)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.72,
    y: 326.52,
    width: 44.28,
    height: 5.58,
    rx: 2.79,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.72,
    y: 338.52,
    width: 44.28,
    height: 5.58,
    rx: 2.79,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.72,
    y: 314.52,
    width: 44.28,
    height: 5.58,
    rx: 2.79,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.72,
    y: 351.38,
    width: 23.95,
    height: 5.58,
    rx: 2.79,
    style: {
      fill: "#bce0fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.44,
    cy: 374.59,
    r: 20.33,
    style: {
      fill: "#00bac6"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "92.65 378.06 100.83 383.65 112.65 369.23",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsDevelopment);
export default __webpack_public_path__ + "static/media/aws-development.d2f1ebec592edcd6b6afc03bc03fd9ad.svg";
export { ForwardRef as ReactComponent };